// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.store/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selWidth[data-v-cb6f1512] {\n  width: 219px !important;\n}\n.seachTiele[data-v-cb6f1512] {\n  line-height: 35px;\n}\n.btnBottom[data-v-cb6f1512] {\n  padding: 10px 0 20px 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
